
<template>
    <transition
        name="slide"
        @before-enter="beforeEnter"
        @enter="enter"
        @after-enter="afterEnter"
        @before-leave="beforeLeave"
        @leave="leave"
        @after-leave="afterLeave"
    >
        <slot/>
    </transition>
</template>

<script>
import velocity from 'velocity-animate';
import { duration, timingFunction as easing } from '@/js/util/transitions';

export default {
    name: 'transition-slide',
    methods: {
        beforeEnter(el) {
            el.style.setProperty('will-change', 'height');
        },
        enter(el, complete) {
            velocity(el, 'slideDown', { easing, duration, complete });
        },
        afterEnter(el) {
            el.style.removeProperty('will-change');
        },
        beforeLeave(el) {
            el.style.setProperty('will-change', 'height');
        },
        leave(el, complete) {
            velocity(el, 'slideUp', { duration, easing, complete });
        },
        afterLeave(el) {
            el.style.removeProperty('will-change');
        },
    },
};
</script>



// WEBPACK FOOTER //
// TransitionPanel.vue?0471d7e9